import React from "react";
import ProjectPerformanceContent from "./ProjectPerformanceContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const ProjectPerformance = () => {
  const { t } = useTranslation();
  const keyGlobalProjects = t("trackRecord.project.keyGlobalProjects.content", { returnObjects: true }) as { name: string; list: string[]; option: string[] }[];
  const greenBuildingEnergy = t("trackRecord.project.greenBuildingEnergy.content", { returnObjects: true }) as { name: string; list: string[]; option: string[] }[];

  return (
    <>
      <Seo title={t("trackRecord.project.seo.title")} description={t("trackRecord.project.seo.des")} path="projects/project-list" />
      <div className="project_performance_wrap" style={{ paddingBottom: "15%" }}>
        <ProjectPerformanceContent title={t("trackRecord.project.keyGlobalProjects.title")} contents={keyGlobalProjects} height="820px" />
        <ProjectPerformanceContent title={t("trackRecord.project.greenBuildingEnergy.title")} contents={greenBuildingEnergy} height="500px" />
      </div>
    </>
  );
};

export default ProjectPerformance;
